import { IconExcel } from "components/icons";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";


export const IconButtonExportExcel: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonExportExcel.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconExcel fixedWidth  />
        </MprcIconButton>
    );
};
